module.exports = __webpack_public_path__ + "media/assets/images/flags/tg-1f749da96420e68a015e9cf8746c54b3.svg";